import Helmet from 'react-helmet'
import { store } from 'app/store'
import { throttle } from 'lodash'

const isThinkPickleDomain =
  window.location.hostname.includes('localhost') ||
  window.location.hostname.includes('thinkpickle.com.au')

const enable =
  GLOBAL_ENV.TYPE === 'browser' && GLOBAL_ENV.NODE_ENV === 'production' && isThinkPickleDomain

const track = (event, properties) =>
  enable
    ? setTimeout(() => {
        if (window.analytics) {
          window.analytics.track(event, properties)
        }
      }, 100)
    : ''

const identify = traits =>
  enable
    ? setTimeout(() => {
        if (window.analytics) {
          const intercomToken = store.getState().auth.user.intercomToken
          const userId = store.getState().auth.user.id
          window.analytics.identify(
            userId,
            traits,
            intercomToken
              ? {
                  integrations: {
                    Intercom: {
                      user_hash: store.getState().auth.user.intercomToken,
                    },
                  },
                }
              : {}
          )
        }
      }, 100)
    : ''

const page = () =>
  enable
    ? setTimeout(() => {
        if (window.analytics) {
          window.analytics.page(Helmet.peek() && Helmet.peek().title, {
            url: window.location.href,
            path: window.location.pathname,
            referrer: document.referrer,
          })
        }
      }, 100)
    : ''

const reset = () =>
  enable
    ? setTimeout(() => {
        if (window.analytics) {
          window.analytics.reset()
        }
        // Logout of intercom
        if (window.Intercom) {
          window.Intercom('shutdown')
        }
      }, 100)
    : ''

export default {
  track,
  identify,
  reset,
  page: throttle(page, 200),
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Analytics/Analytics.utils.js